import React, { useReducer, useState } from 'react';
import Config from '../config/Config';
import WooService from '../services/WooService';

const CategoriesContext = React.createContext();

const config = new Config();

const getActiveCategories = (category) => {
    return config.ACTIVE_CATEGORIES.find(slug => category.slug === slug);
}

const getAllCategories = async () => {
    const wooService = new WooService();
    return await wooService.getWooCategories();
}

const categoriesReducer = (categories, action) => {
    switch (action.type) {
        case 'setCategories':
            return action.payload;
        default:
            return categories;
    }
};

const previousCategoriesReducer = (previousCategories, action) => {
    switch (action.type) {
        case 'push':
            const newValue = previousCategories;
            newValue.push(action.payload);
            return newValue;
        case 'pop':
            return action.payload;
        default:
            return previousCategories;
    }
}

const CategoriesProvider = ({ children }) => {
    const [categories, dispatch] = useReducer(categoriesReducer, []);
    const [allCategories, setAllCategories] = useState([]);
    const [previousCategories, dispatchPrevious] = useReducer(previousCategoriesReducer, []);

    const loadCategories = async () => {
        const loadedCategories = await getAllCategories();
        const activeCategories = loadedCategories.filter(getActiveCategories);
        setAllCategories(loadedCategories);
        dispatch({ type: 'setCategories', payload: activeCategories });
    };

    const setCategories = (categories) => {
        dispatch({ type: 'setCategories', payload: categories });
    }

    const pushCategories = () => {
        dispatchPrevious({ type: 'push', payload: categories });
    }

    const popCategories = () => {
        let newValue = previousCategories;
        let currentCategories = newValue.pop() ?? [];
console.log("currentCategories: ", currentCategories);
console.log("newValue: ", newValue);
        // if (!currentCategories) {
        //    currentCategories = allCategories.filter(getActiveCategories);
        // }
        setCategories(currentCategories);

        dispatchPrevious({ type: 'pop', payload: newValue });
console.log("previous Categories: ", previousCategories);
    }

    const getChildCategories = (parent) => {
        pushCategories();
console.log("previous Categories: ", previousCategories);
        return allCategories.filter(category => category.parent == parent);
    };

    return (
        <CategoriesContext.Provider value={{ categories, previousCategories, loadCategories, setCategories, popCategories, getChildCategories }}>
            {children}
        </CategoriesContext.Provider>
    );
};

export { CategoriesContext, CategoriesProvider };